import { cn } from '#cn';

type BuildDangerButtonClassNameArgs = {
  className?: string;
};

/**
 * Builds the solid-danger pill class string, shared so a non-`<button>` control
 * (e.g. the sign-out `next/link`) wears the exact same styling as the
 * `ConfirmDialog` confirm button – mirrors `buildCardButtonClassName`. Distinct
 * from `CardButton`'s bordered `danger` variant: this is the filled,
 * white-on-danger pill used to confirm a destructive action.
 */
export const buildDangerButtonClassName = ({
  className,
}: BuildDangerButtonClassNameArgs = {}): string =>
  cn(
    'inline-flex items-center justify-center gap-2 rounded-full bg-danger px-5 py-2.5 text-sm font-bold text-fg-inverse transition-colors hover:bg-danger/90 focus:outline-none focus-visible:ring-2 focus-visible:ring-jaaq-black disabled:opacity-50 disabled:cursor-not-allowed',
    className,
  );
